import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("intercom", name, data);

// This is a passive event, called by Intercom when the messenger is shown
// (whether it was opened by the user or by Intercom)
export const intercomMessengerShown = () => event("messenger_shown");

// Passive event, called by Intercom when the messenger is hidden
export const intercomMessengerHidden = () => event("messenger_hidden");

// When the user clicks the 'MessengerItem' button
export const intercomTriggerClicked = () => event("trigger_clicked");
